import request from './http';


export const getSearch = async function (keyWords) {
  return await request.get(`/bzw/articles/findallfront?title[like]=*${keyWords}*&sort=createdAt,DESC`);
}
/**
 * webconfigs
 * @returns 首页数据
 */
export const getFindAll = async function () {
  return await request.get("/bzw/webconfigs/findall");
}
/**
 * plates
 * @returns 首页数据
 */
export const getFindPage = async function () {
  return await request.get("/bzw/categorys/findall?page=1&limit=300");
}
/**
 * NewsHot
 * @returns 
 */
export const getPicNews = function () {
  return request.get("/bzw/articles/findallfront?page=1&limit=10&picnews=1&sort=createdAt,DESC");
}
/**
 * NewsHot
 * @returns 
 */
export const getArticles = function (plateid) {
  return request.get(`/bzw/articles/findallfront?plateid=${plateid}&sort=createdAt,DESC&limit=4`);
}
/**
 * InfoNews
 * @param {*} plateid 
 * @returns 
 */
export const getFindcategory = function (plateid) {
  return request.get(`/bzw/articles/findcategory?plateid=${plateid}&sort=top,DESC;createdAt,DESC&limit=7`);
}
/**
 * 广告
 * @returns 
 */
export const getAd = function () {
  return request.get("/bzw/promotions/findallfront");
}

/**
 * 友情链接
 * @returns 
 */
export const getLiveBlogroll = function () {
  return request.get("/bzw/links/findallfront?sort=createdAt,DESC&limit=100");
}

/**
 * 文章列表
 * @param {*} plateId 
 * @param {*} intCurrent 
 * @returns 
 */
export const getNewsViews = function (plateId, intCurrent) {
  return request.get(`/bzw/articles/findallfront?plateid=${plateId}&page=${intCurrent}&limit=100&sort=createdAt,DESC`);
}

/**
 * 文章
 * @param {*} articleId 
 * @returns 
 */
export const getNewsInfo = function (articleId) {
  return request.get(`/bzw/articles/findone/${articleId}`);
}

/**
 * articleId==="000000"时的处理
 * @param {*} plateId 
 * @returns 
 */
export const getNewsViewsZero = function (plateId) {
  return request.get(`/bzw/articles/findallfront?plateid=${plateId}&sort=createdAt,DESC`);
}